// Dashed overlay shown while the user is dragging files over the
// browser area. Rendered conditionally by Browser.tsx based on the
// `isDragging` flag from useDragDrop.

export function UploadDropzone({ folderPath }: { folderPath: string }) {
  const label = folderPath === "" ? "this vault" : `/${folderPath}`;
  return (
    <div
      className="pointer-events-none absolute inset-0 z-40 flex items-center justify-center rounded-lg border-2 border-dashed border-accent bg-accent-bg/40 backdrop-blur-sm"
      aria-hidden="true"
    >
      <div className="rounded-md bg-bg-raised/90 px-4 py-3 text-sm font-medium text-text shadow-lg">
        Drop files to upload to {label}
      </div>
    </div>
  );
}
